export enum Routes {
  Games = '/games',
  Careers = '/careers',
  Contacts = '/contacts',
  PrivacyPolicy = '/privacy-policy'
}
